


































































































































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwModalBody } from '@libs-uuif/shared/sw-modal';
import { SwScrollView } from '@sonicwall/unified-ui-framework/src/shared/sw-scroll-view';
import  ItemContent  from './item-content.vue';
import { SwButton } from '@libs-uuif/shared/sw-button';
import { SwCheckbox } from '@sonicwall/unified-ui-framework/src/shared/sw-checkbox';
import CreateCustomer from './create-customer.vue';
import { MswApiService } from '../../msw-api-service';
const cssPrefix = 'assign-customers';

@Component({
  components: {
    CreateCustomer,
    SwButton,
    SwCheckbox,
    SwModalBody,
    SwScrollView,
    ItemContent,
  },
})
export default class AssignCustomers extends SwExtendedVue {
  cssPrefix =  cssPrefix;
  selectCustomers: any = [];
  listItems: any = [];
  selectedUserGroupList: any = [];
  selectedCustomerForAssignCustomers: any = [];
  customersToBeAssigned: any[] = [];
  disabledAssigned: boolean = true;
  startIndex = 0;
  endIndex = 0;
  @Prop({ type: Array, required: false })
  selectedCustomer: any;

  @Prop({ type: Array })
  customersList: any;

  @Prop({ type: Array, required: true })
  userGroups: any;

  mounted() {
  }
  created() {
    if (this.$store.getters.isLargeCustomer) {
      this.startIndex = 0;
      this.endIndex = Math.min(this.userGroups.length, 50);
      this.listItems = this.userGroups.slice(this.startIndex, this.endIndex);
      console.warn(this.startIndex);
      console.warn(this.endIndex);
    } else {
      this.listItems = this.userGroups;
    }
  }

  enableDisableAssignButton() {
    this.disabledAssigned = false;
    if (this.selectedUserGroupList.length === 0 || this.customersToBeAssigned.length === 0) {
      this.disabledAssigned = true;
    }
  }

  onCustomerSelect(selectedCustomer: any) {
    this.customersToBeAssigned = selectedCustomer;
    this.enableDisableAssignButton();
  }
  assign() {
    console.warn(this.customersToBeAssigned);
    console.warn(this.selectedUserGroupList);
    console.warn(this.listItems);
    this.$store.commit('startLoading');
    const dataToBePosted1: any = {
      partyProductGroupList: [],
      bsendMail: false,
    };
    this.customersToBeAssigned.forEach((pgEle : any) => {
      this.selectedUserGroupList.forEach((ugEle: any) => {
        const ugIdIndex = this.listItems.findIndex((ele : any) => ele.partyGroupName === ugEle);
        if (ugIdIndex > -1) {
          dataToBePosted1.partyProductGroupList.push({
            productGroupId: pgEle.productGroupId,
            partyGroupId: this.listItems[ugIdIndex].partyGroupId,
          });
        }
      });
    });
    if (dataToBePosted1.partyProductGroupList.length > 0) {
      MswApiService.createCustomer.postManageProductUserGroups(dataToBePosted1)
        .then((resp: any) => {
          if (resp.msgCode === 'MSWAPP:MANAGEPARTYPRODUCTGROUPSUCCESS') {
            this.$store.commit('stopLoading');
            this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
            this.$emit('update-user-group', dataToBePosted1);
          } else {
            this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
            this.$store.commit('stopLoading');
          }
          this.$emit('request-close');
        });
    } else {
      this.$store.commit('stopLoading');
      this.$emit('request-close');
    }
    console.warn(dataToBePosted1);
    // this.customersToBeAssigned.map((ele: any, index: any) => {
    //   const dataToBePosted: any = {
    //     partyProductGroupList: [],
    //     bsendMail: false,
    //   };
    //   this.selectedUserGroupList.map((item: any) => {
    //     const id = this.listItems.findIndex((userEle: any) => userEle.partyGroupName === item);
    //     dataToBePosted.partyProductGroupList.push({
    //       productGroupId: ele.productGroupId,
    //       partyGroupId: this.listItems[id].partyGroupId,
    //     });
    //   });
    //   if (dataToBePosted.partyProductGroupList.length < 0) {
    //     MswApiService.createCustomer.postManageProductUserGroups(dataToBePosted)
    //     .then((resp: any) => {
    //       if (index === (this.customersToBeAssigned.length - 1)) {
    //         if (resp.msgCode === 'MSWAPP:MANAGEPARTYPRODUCTGROUPSUCCESS') {
    //           this.$store.commit('stopLoading');
    //           this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
    //           this.$emit('update-user-group');
    //         } else {
    //           this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
    //           this.$store.commit('stopLoading');
    //         }
    //         this.$emit('request-close');
    //       }
    //     });
    //   } else {
    //     this.$store.commit('stopLoading');
    //     this.$emit('request-close');
    //   }

    // });
  }
  handleScroll(e : any) {
    if (e.srcElement && (e.srcElement.scrollHeight - e.srcElement.scrollTop - e.srcElement.clientHeight < 1) && this.$store.getters.isLargeCustomer) {
      console.warn('hit bottom');
      const offSet = Math.min(this.userGroups.length, this.endIndex + 20);
      for (let i = this.endIndex ; i < offSet ; i += 1) {
        this.listItems.push(this.userGroups[i]);
      }
      this.endIndex = offSet;
      console.warn(this.endIndex);
      console.warn(this.startIndex);
    }
  }
}
